<template>
  <v-navigation-drawer
    v-model="display"
    temporary
    floating
    :width="300"
    color="#0D171A"
  >
    <v-list
      nav
      flat
      dense
    >
      <navigation-item
        title="Masters Liga"
        link="/masters-liga"
        icon="fa-trophy"
        locked
      />
      <navigation-item
        title="Mega League"
        link="/mega-league"
        icon="fa-medal"
      />
      <navigation-item
        v-if="hasRoleAdmin"
        title="Admin"
        link="/admin"
        icon="fa-user-gear"
      />
    </v-list>
    <template #append>
      <navigation-drawer-append />
    </template>
  </v-navigation-drawer>
</template>

<script>
import NavigationItem from '@/components/NavDrawer/NavigationItem.vue';
import NavigationDrawerAppend from '@/components/NavDrawer/NavigationDrawerAppend.vue';
import { useUserStore } from '@/store/user.module';
import { useAuthStore } from '@/store/auth.module';

export default {
  name: 'NavigationDrawer',
  components: {
    NavigationItem,
    NavigationDrawerAppend,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    display: {
      get() { return this.modelValue; },
      set(display) { this.$emit('update:model-value', display); },
    },
    user() {
      return useUserStore().currentUser;
    },
    hasRoleAdmin() {
      return useAuthStore().hasRoleAdmin;
    },
  },
};
</script>

<style lang="scss">
.currency {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 32px 0;
}
</style>
